import api from "../../../store/AuthHeader";

const loadEmployer = () => {
    return api.get("/Employer/LoadEmployerDetails");
};

const addEmployer = (payload: any) => {
    return api.post("/Employer", payload);
};

const getEmployers = () => {
    return api.get("/Employer/GetAllEmployers");
};

const archiveEmployer = (payload: any) => {
    return api.put(`Employer/ArchiveEmployer`, payload);
};

const unArchiveEmployer = (payload: any) => {
    return api.put(`Employer/UnArchiveEmployer`, payload);
};

const deleteEmployer = (id: number) => {
    return api
        .delete(`/Employer/${id}`);
};

const getWorkActivityCount = () => {
    return api
        .get(`/Employer/GetMemberWorkActivityCount`);
};

const addDefaultMemberWorkActivity = () => {
    return api.post('/MemberWorkActivity/AddDefaultWorkActivity', null);
}

const updateEmployer = (payload: any) => {
    return api.put(`/Employer/${payload.id}`, payload);
};

export default {
    loadEmployer,
    addEmployer,
    getEmployers,
    archiveEmployer,
    unArchiveEmployer,
    deleteEmployer,
    getWorkActivityCount,
    addDefaultMemberWorkActivity,
    updateEmployer
};